import StandardError from '../StandardError'

export default class DeleteSupportedOrderError extends StandardError {
  constructor() {
    super('This order cannot be deleted because it has not yet been processed.')
  }
}
